var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2273 36.7727H36.7727M27.5 27.5V36.7727M13.5909 13.5909V11.2727C13.5909 4.31818 17.0682 2 22.8636 2H32.1364C37.9318 2 41.4091 5.47727 41.4091 11.2727V13.5909C48.3636 13.5909 53 18.2273 53 25.1818C53 32.1364 48.3636 36.7727 41.4091 36.7727M13.5909 13.5909H32.1364M13.5909 13.5909C6.63636 13.5909 2 17.0682 2 25.1818C2 33.2955 6.63636 36.7727 13.5909 36.7727M18.2273 53H36.7727V27.5H18.2273V53Z",
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.78fc9bf26d7a0d2adad830e5fe52ce4a.svg";
export { ForwardRef as ReactComponent };